<app-version></app-version>
<router-outlet></router-outlet>
